// extracted by mini-css-extract-plugin
export default {"profile":"Biography_profile__uCmzv","name":"Biography_name__QqFDN","subhead":"Biography_subhead__loqmO","body":"Biography_body__SwHLI","image":"Biography_image__veZjo"};